"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeFromChannel = exports.storefrontToChannelLocale = exports.mapLocale = exports.LocaleMap = exports.normalizeLocale = void 0;
const ct_1 = require("./ct");
const i18n_1 = require("./i18n");
function normalizeLocale(locale) {
    return locale.toLowerCase().replace(/_/g, '-');
}
exports.normalizeLocale = normalizeLocale;
class LocaleMap {
    constructor(locale) {
        this['en-gb'] = false;
        this['en-ie'] = false;
        this['en-us'] = false;
        this['en-outlet'] = false;
        this['fr-ca'] = false;
        this['en-ca'] = false;
        switch (locale) {
            case 'en-ie': {
                this['en-ie'] = true;
                break;
            }
            case 'en-us': {
                this['en-us'] = true;
                break;
            }
            case 'en-vg':
            case 'en-gb-outlet': {
                this['en-outlet'] = true;
                break;
            }
            case 'fr-ca': {
                this['fr-ca'] = true;
                break;
            }
            case 'en-ca': {
                this['en-ca'] = true;
                break;
            }
            case 'en-gb': {
                this['en-gb'] = true;
                break;
            }
            default: {
                break;
            }
        }
        this.locale = locale;
    }
}
exports.LocaleMap = LocaleMap;
function mapLocale(locale) {
    return locale ? new LocaleMap(normalizeLocale(locale)) : undefined;
}
exports.mapLocale = mapLocale;
const enRoeLocales = [
    'en-at',
    'en-be',
    'en-bg',
    'en-ch',
    'en-cy',
    'en-cz',
    'en-dk',
    'en-fi',
    'en-gr',
    'en-hr',
    'en-hu',
    'en-it',
    'en-li',
    'en-lu',
    'en-lv',
    'en-mt',
    'en-pl',
    'en-pt',
    'en-ro',
    'en-se',
    'en-sk',
];
const frRoeLocales = ['fr-be', 'fr-ch', 'fr-lu'];
const itRoeLocales = ['it-ch'];
const nlRoeLocales = ['nl-be'];
const deRoeLocales = ['de-at', 'de-ch'];
const roeLocaleMap = {
    en: enRoeLocales,
    fr: frRoeLocales,
    it: itRoeLocales,
    nl: nlRoeLocales,
    de: deRoeLocales,
};
/**
 * Maps storefront to channel specific locale.
 * This takes in account edge cases around ROE locales where they are mapped from other channels
 * (Eg: de-ch being mapped to the eCommerceDE channel and en-ch being mapped to eCommerceEU)
 */
const storefrontToChannelLocale = (locale, channel) => {
    const localeParts = locale.toLowerCase().split('-');
    const [language] = localeParts;
    if (channel === ct_1.ChannelFromEvent.OUTLET_UK) {
        return 'en_GB_OUTLET';
    }
    const isStar2EnLanguage = language === 'en' &&
        ![
            ct_1.ChannelFromEvent.UK,
            ct_1.ChannelFromEvent.OUTLET_UK,
            ct_1.ChannelFromEvent.ROI,
            ct_1.ChannelFromEvent.US,
            ct_1.ChannelFromEvent.CA,
        ].includes(channel);
    const isRoeLocale = channel === ct_1.ChannelFromEvent.ROE && roeLocaleMap[language] && roeLocaleMap[language].includes(locale);
    let country = localeParts[1];
    if (isRoeLocale) {
        country = language === 'en' ? 'EU' : language;
    }
    else if (isStar2EnLanguage) {
        country = 'EU';
    }
    const channelLocale = `${language.toLowerCase()}_${country.toUpperCase()}`;
    if (!ct_1.localesConfluent.includes(channelLocale) && !isStar2EnLanguage) {
        throw new Error(`${channelLocale} is not a valid locale for channel=${channel}`);
    }
    return channelLocale;
};
exports.storefrontToChannelLocale = storefrontToChannelLocale;
/**
 * Maps channel to multiple locale formats used within our ecosystem
 */
const localeFromChannel = (channel) => {
    const ctLocales = ct_1.channelToLocale[channel] || [];
    const storefrontLocales = ctLocales
        .map((locale) => (0, ct_1.ctLocaleToStoreLocales)(locale))
        .flat()
        .filter((locale) => !(0, i18n_1.isDeactivatedStoreLocale)(locale))
        .map((locale) => locale.toLowerCase());
    return {
        storefrontLocale: storefrontLocales[0],
        storefrontLocales,
        ctLocale: ctLocales[0],
        ctLocales,
    };
};
exports.localeFromChannel = localeFromChannel;
//# sourceMappingURL=locale.js.map